import { Navigate, useNavigate } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { Brand } from "../components/Layout";
import { Loading } from "../components/kit";
import PasswordForm from "../components/PasswordForm";

export default function ChangePassword() {
  const { user, refresh, logout } = useAuth();
  const navigate = useNavigate();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (!user.must_change_password) return <Navigate to="/" replace />;

  return (
    <div className="min-h-screen bg-[#FAF9F6]">
      <div className="bs-navy-panel h-16 px-6 flex items-center"><Brand /></div>
      <div className="max-w-md mx-auto px-5 py-10 bs-rise">
        <ShieldCheck className="w-10 h-10 text-[#C5A059]" />
        <h1 className="font-display text-3xl font-bold text-[#011E38] mt-4" data-testid="force-change-title">Set your own password</h1>
        <p className="text-slate-500 mt-2 mb-8">
          Welcome, {user.name}. You signed in with a temporary password. Choose a new one — only you will know it.
        </p>
        <div className="bs-card p-6">
          <PasswordForm currentLabel="Temporary password" onDone={async () => { await refresh(); navigate("/"); }} />
        </div>
        <button onClick={logout} className="mt-6 text-sm text-slate-500 underline w-full" data-testid="force-change-logout">Sign out</button>
      </div>
    </div>
  );
}
